import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../context/LangContext";

interface PageLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  backTo?: string;
  onBack?: () => void; // 👈 yangi: custom back action
  backLabel?: string; // 👈 yangi: "Orqaga" ni o'zgartirish
}

const PageLayout: React.FC<PageLayoutProps> = ({
  title,
  subtitle,
  children,
  backTo = "/dashboard",
}) => {
  const navigate = useNavigate();
  const { t } = useLang();

  return (
    <div style={{ minHeight: "100vh", background: "var(--bg)" }}>
      <div
        style={{
          maxWidth: 620,
          margin: "0 auto",
          padding: "20px 16px 40px",
        }}>
        <button
          onClick={() => navigate(backTo)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            background: "transparent",
            border: "none",
            color: "var(--muted)",
            cursor: "pointer",
            marginBottom: 20,
            fontSize: 13,
            fontWeight: 600,
            padding: 0,
            transition: "color .2s",
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLElement).style.color = "#fff";
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLElement).style.color = "var(--muted)";
          }}>
          <ArrowLeft size={16} />
          {t("back")}
        </button>

        <h1
          style={{
            color: "#fff",
            fontSize: 22,
            fontWeight: 800,
            marginBottom: 4,
            letterSpacing: "-0.5px",
          }}>
          {title}
        </h1>
        {subtitle && (
          <p
            style={{
              color: "var(--muted)",
              fontSize: 13,
              marginBottom: 24,
            }}>
            {subtitle}
          </p>
        )}

        {children}
      </div>
    </div>
  );
};

export default PageLayout;
